import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
      <h1 className="text-6xl font-bold text-danger mb-4">404</h1>
      <p className="text-xl mb-6">{t('notFound.message')}</p>
      <Link to="/" className="bg-primary text-white px-6 py-2 rounded hover:bg-secondary transition-colors">{t('common.backToHome')}</Link>
    </div>
  );
};

export default NotFound;
